import ContentLoader from 'react-content-loader'
import { AnnouncementListItem, AnnouncementListItemCard } from './styles'

const Loading = ({ length = 2 }) => {
  const arr = []
  for (let i = 0; i < length; i++) {
    arr.push(i)
  }

  return (
    <ul>
      {arr.map(loader => (
        <AnnouncementListItem key={`loading-${loader}`}>
          <AnnouncementListItemCard>
            <ContentLoader
              width={640}
              height={108}
              speed={2}
              primaryColor="#F1F1F1"
              secondaryColor="#FBFBFB"
              title=""
            >
              <rect x="0" y="0" width="35" height="35" />
              <rect x="540" y="0" width="100" height="15" />

              <rect x="0" y="60" width="100%" height="20" />
              <rect x="0" y="90" width="75%" height="25" />
            </ContentLoader>
          </AnnouncementListItemCard>
        </AnnouncementListItem>
      ))}
    </ul>
  )
}

export default Loading
